/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './index.scss';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { ExternalAppProviders } from 'shared-ui/external-app-base';
import { RestoreScroll } from 'shared-ui/components/RestoreScroll/RestoreScroll';

import App from './App';
import store from './store';

const root = createRoot(document.getElementById('recApp') as HTMLElement);

root.render(
    <Provider store={store}>
        <ExternalAppProviders>
            <BrowserRouter>
                <RestoreScroll />
                <App />
            </BrowserRouter>
        </ExternalAppProviders>
    </Provider>
);
